module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-items', [_c('v-tabs', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.props))]), _vm._v(" "), _c('v-tab', [_vm._v("Andere Chargen")]), _vm._v(" "), _c('v-tab', [_vm._v("Neu")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "pt-0 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('todoSeite', {
    attrs: {
      "ToDo": "false",
      "showTitle": _vm.props.text,
      "wer": _vm.props,
      "anzahl": "-1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-col', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('todoSeite', {
    attrs: {
      "ToDo": "false",
      "showTitle": "Andere Chargen",
      "wer": "alle",
      "anzahl": "-1"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('todoSeite', {
    attrs: {
      "ToDo": "true"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce451c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/todo.vue
// module id = 749
// module chunks = 15